import CourseInfoTab from './tabs/CourseInfoTab'
import CourseNewsTab from './tabs/CourseNewsTab'
import CourseSubjectTab from './tabs/CourseSubjectTab'
import CourseTeacherTab from './tabs/CourseTeacherTab'

export const courseRouteEntities = [
  {
    path: 'overview',
    component: CourseInfoTab,
    breadcrumbName: (t) => t('overview'),
  },
  {
    path: 'news',
    component: CourseNewsTab,
    breadcrumbName: (t) => t('news'),
    isInvisible: (props) => !!props?.item?.warnings,
  },
  {
    path: 'subjects',
    component: CourseSubjectTab,
    breadcrumbName: (t) => t('subjects'),
    isInvisible: (props) => !!props?.item?.warnings,
    // Đã có preview "Khung chương trình" ngay ở tab overview (CourseInfoTab.js) - ẩn khỏi thanh
    // tab cho đỡ trùng lặp, nhưng route vẫn còn (nút "Quản lý" trong preview trỏ tới đây).
    hideFromNav: true,
  },
  {
    path: 'teachers',
    component: CourseTeacherTab,
    breadcrumbName: (t) => t('course committee'),
    isInvisible: (props) => !!props?.item?.warnings,
    // Đã có preview "Ban giảng huấn" ngay ở tab overview (CourseInfoTab.js) - ẩn khỏi thanh tab
    // cho đỡ trùng lặp, nhưng route vẫn còn (nút "Quản lý" trong preview trỏ tới đây).
    hideFromNav: true,
  },
]
